import { createFileRoute } from '@tanstack/react-router';

/**
 * This is a LEGACY route!
 * Route definition for wrapper library
 */
export const Route = createFileRoute('/forms/submissions/inbox/retry-sync')({
  staticData: { team: 'forms' },
});
